import { useState, useEffect, forwardRef } from 'react'
import { Tooltip, Button } from 'antd'
import { UserOutlined, DownOutlined } from '@ant-design/icons'

const MAX_USERNAME_DISPLAY_LEN = 28

const UserProfile = forwardRef((props, ref) => {
  const { onClick, isMenuOpen, toggleMenu } = props

  const toggleUserMenu = (e) => {
    onClick(e)
    toggleMenu(!isMenuOpen)
  }

  return (
    <div className="collapsible" ref={ref}>
      <Button
        onClick={toggleUserMenu}
        className="user-menu-button"
        data-testid="usermenu-button"
      >
        <UserOutlined />
        <DownOutlined data-testid="toggle-icon" />
      </Button>
    </div>
  )
})

export default UserProfile
